import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Box,
} from "@mui/material";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import axios from "axios"; // Directly import axios
import API_BASE_URL from '../../src/config'; 

const EventDetails = () => {
  const { id } = useParams(); // Get event id from the URL
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch event details from API directly using axios
    const fetchEventDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/events/${id}`); 
        // const response = await axios.get(`http://localhost:5000/api/events/${id}`);
        setEvent(response.data); // Set event data
        setLoading(false);
      } catch (err) {
        setError("Failed to load event details. Please try again later.");
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [id]);

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ textAlign: "center", mt: 5}}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ textAlign: "center", mt: 5 }}>
        <Typography color="error">{error}</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb:4 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" color="#42326e"  fontWeight="bold">
            {event.name}
          </Typography>

          <Box display="flex" alignItems="center" mt={1}>
            <CalendarTodayIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body2">
              {new Date(event.event_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </Typography>
          </Box>


          <Box display="flex" alignItems="center" mt={1}>
            <LocationOnIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body1">
              <strong>{event.location}</strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" mt={1}>
            <EventAvailableIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body2">{event.event_type}</Typography>
          </Box>

          <Typography sx={{ mt: 2, fontSize: "1rem" }}>{event.details}</Typography>

          <Button
            variant="contained"
            color="success"
            sx={{ mt: 3, width: "100%" }}
            startIcon={<EventAvailableIcon />}
            onClick={() => navigate(`/booktickets/${event.id}`, { state: { event } })  }
          >
            Register Now
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/events")}
            sx={{ mt: 3, width: "100%" }}
          >
            Back to Events
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default EventDetails;
